import { useTranslation } from 'react-i18next';
import { useAppSelector } from '@platform/state/hooks';
import { websiteUrl } from '../shell/websiteUrl';
import type { IAuthFrameProps } from './IAuthFrameProps';
import './auth.css';

/**
 * Рамка екранів входу й реєстрації (прототип v4 isAuth): ліворуч — логотип «P Офіс парламентаря», гасло, домен і «← На
 * parliamentarian-office.com» (головна вебсайту мовою інтерфейсу); праворуч — форма по центру.
 */
export function AuthFrame({ children }: IAuthFrameProps) {
  const { t } = useTranslation();
  const lang = useAppSelector((s) => s.session.lang);
  return (
    <div className="au">
      <div className="au__side">
        <div className="au__brand"><span className="au__logo" aria-hidden="true">P</span><span className="au__product">{t('auth.product')}</span></div>
        <div className="au__pitch">
          <div className="au__headline">{t('auth.headline')}</div>
          <div className="au__domain">parliamentarian-office.com</div>
        </div>
        <a className="au__back" href={websiteUrl(lang)}>{t('auth.back')}</a>
      </div>
      <div className="au__main">{children}</div>
    </div>
  );
}
